import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

import { UnboxedModule } from '@fry/ui';
import { EligibilityEditorModule } from '@fry/booking/eligibility-editor';
import { TranslationEditorModule } from '@fry/booking/translation-editor';
import { MaterialModule } from '@fry/components/material';
import { UIBadgeModule } from '@fry/ui/badge';

import { EditorBookingItemComponent } from './editor-booking-item/editor-booking-item.component';
import {
  EditorBookingItemBookingComponent
} from './editor-booking-item-booking/editor-booking-item-booking.component';
import {
  EditorBookingItemBookingFormComponent
} from './editor-booking-item-booking-form/editor-booking-item-booking-form.component';
import {
  EditorBookingItemBulkNameEditComponent
} from './editor-booking-item-bulk-name-edit/editor-booking-item-bulk-name-edit.component';
import {
  EditorBookingItemBulkNameSearchReplaceComponent
} from './editor-booking-item-bulk-name-search-replace/editor-booking-item-bulk-name-search-replace.component';
import {
  EditorBookingItemBulkNameEditStore
} from './editor-booking-item-bulk-name-edit/editor-booking-item-bulk-name-edit.store';
import {
  EditorBookingItemBundleComponent
} from './editor-booking-item-bundle/editor-booking-item-bundle.component';
import {
  EditorBookingItemBundleFormComponent
} from './editor-booking-item-bundle-form/editor-booking-item-bundle-form.component';
import {
  EditorBookingItemBundleSummaryComponent
} from './editor-booking-item-bundle-summary/editor-booking-item-bundle-summary.component';
import {
  EditorBookingItemEditComponent
} from './editor-booking-item-edit/editor-booking-item-edit.component';
import {
  EditorBookingItemEditStore
} from './editor-booking-item-edit/editor-booking-item-edit.store';
import {
  EditorBookingItemExportDialogComponent
} from './editor-booking-item-export-dialog/editor-booking-item-export-dialog.component';
import {
  EditorBookingItemInheritableTypeBadgeComponent
} from './editor-booking-item-inheritable-type-badge/editor-booking-item-inheritable-type-badge.component';
import {
  EditorBookingItemInheritableTypeHeaderDirective
} from './editor-booking-item-inheritable-type-header/item-inheritable-type-header.directive';
import {
  EditorBookingItemMetadataListComponent
} from './editor-booking-item-metadata-list/editor-booking-item-metadata-list.component';
import {
  EditorBookingItemMetadataListFormComponent
} from './editor-booking-item-metadata-list-form/editor-booking-item-metadata-list-form.component';
import {
  EditorBookingItemNameFormComponent
} from './editor-booking-item-name-form/editor-booking-item-name-form.component';
import {
  EditorBookingItemOptionComponent
} from './editor-booking-item-option/editor-booking-item-option.component';
import {
  EditorBookingItemOptionListComponent
} from './editor-booking-item-option-list/editor-booking-item-option-list.component';
import {
  EditorBookingItemOptionSummaryComponent
} from './editor-booking-item-option-summary/editor-booking-item-option-summary.component';
import {
  EditorBookingItemRootEditComponent
} from './editor-booking-item-root-edit/editor-booking-item-root-edit.component';
import {
  EditorBookingItemSettingComponent
} from './editor-booking-item-setting/editor-booking-item-setting.component';
import {
  EditorBookingItemSettingSummaryWorkflowComponent
} from './editor-booking-item-setting-summary/editor-booking-item-setting-summary-workflow.component';
import {
  EditorBookingItemSettingSummaryBookingDateComponent
} from './editor-booking-item-setting-summary/editor-booking-item-setting-summary-booking-date.component';
import {
  EditorBookingItemSettingSummaryBookingWindowComponent
} from './editor-booking-item-setting-summary/editor-booking-item-setting-summary-booking-window.component';
import {
  EditorBookingItemSettingSummaryCapacityComponent
} from './editor-booking-item-setting-summary/editor-booking-item-setting-summary-capacity.component';
import {
  EditorBookingItemSettingSummaryEligibilityComponent
} from './editor-booking-item-setting-summary/editor-booking-item-setting-summary-eligibility.component';
import {
  EditorBookingItemSettingSummaryPricingComponent
} from './editor-booking-item-setting-summary/editor-booking-item-setting-summary-pricing.component';
import {
  EditorBookingItemSettingSummaryVenueComponent
} from './editor-booking-item-setting-summary/editor-booking-item-setting-summary-venue.component';
import {
  EditorBookingItemSettingValueWorkflowComponent
} from './editor-booking-item-setting-value/editor-booking-item-setting-value-workflow.component';
import {
  EditorBookingItemSettingValueBookingDateComponent
} from './editor-booking-item-setting-value/editor-booking-item-setting-value-booking-date.component';
import {
  EditorBookingItemSettingValueBookingWindowComponent
} from './editor-booking-item-setting-value/editor-booking-item-setting-value-booking-window.component';
import {
  EditorBookingItemSettingValueCapacityComponent
} from './editor-booking-item-setting-value/editor-booking-item-setting-value-capacity.component';
import {
  EditorBookingItemSettingValueEligibilityComponent
} from './editor-booking-item-setting-value/editor-booking-item-setting-value-eligibility.component';
import {
  EditorBookingItemSettingValuePricingComponent
} from './editor-booking-item-setting-value/editor-booking-item-setting-value-pricing.component';
import {
  EditorBookingItemSettingValueVenueComponent
} from './editor-booking-item-setting-value/editor-booking-item-setting-value-venue.component';
import {
  EditorBookingItemSettingFormComponent
} from './editor-booking-item-setting-form/editor-booking-item-setting-form.component';
import {
  EditorBookingItemSettingFieldBookingDateStartComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-booking-date-start.component';
import {
  EditorBookingItemSettingFieldBookingDateEndComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-booking-date-end.component';
import {
  EditorBookingItemSettingFieldBookingDateTimezoneComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-booking-date-timezone.component';
import {
  EditorBookingItemSettingFieldBookingWindowOpenComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-booking-window-open.component';
import {
  EditorBookingItemSettingFieldBookingWindowCloseComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-booking-window-close.component';
import {
  EditorBookingItemSettingFieldBookingWindowTimezoneComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-booking-window-timezone.component';
import {
  EditorBookingItemSettingFieldCapacityAvailableComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-capacity-available.component';
import {
  EditorBookingItemSettingFieldPricingPriceComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-pricing-price.component';
import {
  EditorBookingItemSettingFieldPricingCurrencyComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-pricing-currency.component';
import {
  EditorBookingItemSettingFieldPricingMethodsComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-pricing-methods.component';
import {
  EditorBookingItemSettingFieldVenueIdComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-venue-id.component';
import {
  EditorBookingItemSettingFieldWorkflowIdComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-workflow-id.component';
import {
  EditorBookingItemSettingFieldEligibilityIdComponent
} from './editor-booking-item-setting-field/editor-booking-item-setting-field-eligibility-id.component';
import {
  EditorBookingItemStateActionComponent
} from './editor-booking-item-state-action/editor-booking-item-state-action.component';
import {
  EditorBookingItemTreeCreateComponent
} from './editor-booking-item-tree-create/editor-booking-item-tree-create.component';
import {
  EditorBookingItemTreeEditComponent
} from './editor-booking-item-tree-edit/editor-booking-item-tree-edit.component';
import {
  EditorBookingItemTreeComponent
} from './editor-booking-item-tree/editor-booking-item-tree.component';
import {
  EditorBookingItemTreeService
} from './editor-booking-item-tree/editor-booking-item-tree.service';
import {
  EditorBookingItemTreeStore
} from './editor-booking-item-tree/editor-booking-item-tree.store';
import {
  EditorBookingItemTreeBookingTypeComponent
} from './editor-booking-item-tree-booking-type/editor-booking-item-tree-booking-type.component';
import {
  EditorBookingItemTreeBookingTypeFormComponent
} from './editor-booking-item-tree-booking-type-form/editor-booking-item-tree-booking-type-form.component';
import {
  EditorBookingItemTreeExtraRolesComponent
} from './editor-booking-item-tree-extra-roles/editor-booking-item-tree-extra-roles.component';
import {
  EditorBookingItemTreeExtraRolesFormComponent
} from './editor-booking-item-tree-extra-roles-form/editor-booking-item-tree-extra-roles-form.component';
import {
  EditorBookingItemTreeDataEditComponent
} from './editor-booking-item-tree-data-edit/editor-booking-item-tree-data-edit.component';
import {
  EditorBookingItemTreeDataEditStore
} from './editor-booking-item-tree-data-edit/editor-booking-item-tree-data-edit.store';
import { EditorDataService } from './editor-data/editor-data.service';
import { EditorDialogStore } from './editor-dialog/editor-dialog.store';
import {
  EditorEligibilityEditorLoaderComponent
} from './editor-eligibility-editor-loader/editor-eligibility-editor-loader.component';
import {
  EditorWorkflowEditorLoaderComponent
} from './editor-workflow-editor-loader/editor-workflow-editor-loader.component';
import {
  EditorBookingItemTreeExamTypeComponent
} from "@fry/booking/booking-item-editor/editor-booking-item-tree-exam-type/editor-booking-item-tree-exam-type.component";
import {
  EditorBookingItemTreeExamTypeFormComponent
} from "@fry/booking/booking-item-editor/editor-booking-item-tree-exam-type-form/editor-booking-item-tree-exam-type-form.component";


// TODO: TIMEZONE PICKER
// We need to do npm install svelte-timezone-picker
// Then the file below needs to be removed and the import replaced with the one coming from the node_module
// import './timezone-picker.js';

@NgModule({
  declarations: [
    EditorBookingItemComponent,
    EditorBookingItemBookingComponent,
    EditorBookingItemBookingFormComponent,
    EditorBookingItemBulkNameEditComponent,
    EditorBookingItemBulkNameSearchReplaceComponent,
    EditorBookingItemBundleComponent,
    EditorBookingItemBundleFormComponent,
    EditorBookingItemBundleSummaryComponent,
    EditorBookingItemEditComponent,
    EditorBookingItemExportDialogComponent,
    EditorBookingItemInheritableTypeBadgeComponent,
    EditorBookingItemInheritableTypeHeaderDirective,
    EditorBookingItemMetadataListComponent,
    EditorBookingItemMetadataListFormComponent,
    EditorBookingItemNameFormComponent,
    EditorBookingItemOptionComponent,
    EditorBookingItemOptionListComponent,
    EditorBookingItemOptionSummaryComponent,
    EditorBookingItemRootEditComponent,
    EditorBookingItemSettingComponent,
    EditorBookingItemSettingSummaryWorkflowComponent,
    EditorBookingItemSettingSummaryBookingDateComponent,
    EditorBookingItemSettingSummaryBookingWindowComponent,
    EditorBookingItemSettingSummaryCapacityComponent,
    EditorBookingItemSettingSummaryEligibilityComponent,
    EditorBookingItemSettingSummaryPricingComponent,
    EditorBookingItemSettingSummaryVenueComponent,
    EditorBookingItemSettingValueWorkflowComponent,
    EditorBookingItemSettingValueBookingDateComponent,
    EditorBookingItemSettingValueBookingWindowComponent,
    EditorBookingItemSettingValueCapacityComponent,
    EditorBookingItemSettingValueEligibilityComponent,
    EditorBookingItemSettingValuePricingComponent,
    EditorBookingItemSettingValueVenueComponent,
    EditorBookingItemSettingFormComponent,
    EditorBookingItemSettingFieldBookingDateStartComponent,
    EditorBookingItemSettingFieldBookingDateEndComponent,
    EditorBookingItemSettingFieldBookingDateTimezoneComponent,
    EditorBookingItemSettingFieldBookingWindowOpenComponent,
    EditorBookingItemSettingFieldBookingWindowCloseComponent,
    EditorBookingItemSettingFieldBookingWindowTimezoneComponent,
    EditorBookingItemSettingFieldCapacityAvailableComponent,
    EditorBookingItemSettingFieldPricingPriceComponent,
    EditorBookingItemSettingFieldPricingCurrencyComponent,
    EditorBookingItemSettingFieldPricingMethodsComponent,
    EditorBookingItemSettingFieldVenueIdComponent,
    EditorBookingItemSettingFieldWorkflowIdComponent,
    EditorBookingItemSettingFieldEligibilityIdComponent,
    EditorBookingItemTreeCreateComponent,
    EditorBookingItemTreeEditComponent,
    EditorBookingItemTreeComponent,
    EditorBookingItemTreeBookingTypeComponent,
    EditorBookingItemTreeBookingTypeFormComponent,
    EditorBookingItemTreeExamTypeComponent,
    EditorBookingItemTreeExamTypeFormComponent,
    EditorBookingItemTreeExtraRolesComponent,
    EditorBookingItemTreeExtraRolesFormComponent,
    EditorBookingItemTreeDataEditComponent,
    EditorBookingItemStateActionComponent,
    EditorEligibilityEditorLoaderComponent,
    EditorWorkflowEditorLoaderComponent
  ],
  imports: [
    CommonModule,
    EligibilityEditorModule,
    TranslationEditorModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatMomentDateModule,
    MaterialModule,
    UIBadgeModule,
    UnboxedModule
  ],
  providers: [
    EditorBookingItemBulkNameEditStore,
    EditorBookingItemEditStore,
    EditorBookingItemTreeService,
    EditorBookingItemTreeStore,
    EditorBookingItemTreeDataEditStore,
    EditorDataService,
    EditorDialogStore
  ]
  // schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BookingItemEditorModule {

}
